import React from "react";
import "./Design/privacy.css";

const ConatactUs = () => {
  return (
    <>
      <div className="container main-container">
        <h1 className="privacy-container">Contact Us </h1>

        <div className="privacy-container para">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam
          minima dignissimos temporibus debitis nostrum explicabo architecto est
          natus quisquam repudiandae. Consequatur culpa neque quae
          reprehenderit, vel similique dignissimos? Dicta eos culpa voluptatibus
          quis cumque at fugiat, doloremque qui vero officiis aliquid nostrum
          sunt quia nobis laboriosam a provident delectus dolorum blanditiis.
          Voluptate deleniti dolore laboriosam necessitatibus. At accusamus est
          blanditiis quas, dolores deleniti esse possimus rerum praesentium nemo
          neque repellat ad amet sit quasi. Velit, quasi? Velit perferendis est
          facere deleniti. Corrupti modi, doloremque tempore provident dolorem
          blanditiis nobis hic quibusdam minima corporis distinctio, minus
          commodi ea consequatur eligendi magni. Lorem ipsum dolor sit amet
          consectetur adipisicing elit. Quibusdam minima dignissimos temporibus
          debitis nostrum explicabo architecto est natus quisquam repudiandae.
          Consequatur culpa neque quae reprehenderit, vel similique dignissimos?
          Dicta eos culpa voluptatibus quis cumque at fugiat, doloremque qui
          vero officiis aliquid nostrum sunt quia nobis laboriosam a provident
          delectus dolorum blanditiis. Voluptate deleniti dolore laboriosam
          necessitatibus. At accusamus est blanditiis quas, dolores deleniti
          esse possimus rerum praesentium nemo neque repellat ad amet sit quasi.
          Velit, quasi? Velit perferendis est facere deleniti. Corrupti modi,
          doloremque tempore provident dolorem blanditiis nobis hic quibusdam
          minima corporis distinctio, minus commodi ea consequatur eligendi
          magni. Lorem ipsum dolor sit amet consectetur adipisicing elit.
          Quibusdam minima dignissimos temporibus debitis nostrum explicabo
          architecto est natus quisquam repudiandae. Consequatur culpa neque
          quae reprehenderit, vel similique dignissimos? Dicta eos culpa
          voluptatibus quis cumque at fugiat, doloremque qui vero officiis
          aliquid nostrum sunt quia nobis laboriosam a provident delectus
          dolorum blanditiis. Voluptate deleniti dolore laboriosam
          necessitatibus. At accusamus est blanditiis quas, dolores deleniti
          esse possimus rerum praesentium nemo neque repellat ad amet sit quasi.
          Velit, quasi? Velit perferendis est facere deleniti. Corrupti modi,
          doloremque tempore provident dolorem blanditiis nobis hic quibusdam
          minima corporis distinctio, minus commodi ea consequatur eligendi
          magni.
        </div>
      </div>
    </>
  );
};

export default ConatactUs;
